import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { DowLoader } from './DowLoader';

export const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return <DowLoader fullscreen size="xl" label="Loading" />;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
